__turbopack_context__.v({
  "__required-star": "opt-in-text-module-scss-module__CY7dHq____required-star",
  "opt-in-text": "opt-in-text-module-scss-module__CY7dHq__opt-in-text",
});
